import React from 'react';
import { Link } from 'react-router-dom';
import { FiPhone, FiMail, FiMapPin, FiFacebook, FiInstagram, FiYoutube } from 'react-icons/fi';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-top">
        <div className="container footer-top-inner">

          {/* Brand col */}
          <div className="footer-brand-col">
            <Link to="/" className="footer-logo">
              <div className="footer-logo-mark">P</div>
              <div>
                <span className="footer-logo-name">PrinterPart<span>Spare</span></span>
                <span className="footer-logo-tag">Ap Tech Solution</span>
              </div>
            </Link>
            <p>India's trusted source for genuine and compatible printer parts. Serving technicians, print shops, and businesses pan-India since 2014.</p>
            <div className="footer-contact">
              <a href="tel:+919990774445"><FiPhone size={13} /> +91 8467025204</a>
              <a href="mailto:info@printerpartspoint.com"><FiMail size={13} /> info@printerpartspare.com</a>
              <span>
                <FiMapPin size={13} />
                River side club house number 110 
                vill chilla mayur vihar extension Delhi
            
              </span>
              <span style={{ fontSize: 12, color: '#6B7280', marginTop: 4 }}>
                GST: 07DSZPM2011R1ZY &nbsp;|&nbsp; CIN: 
              </span>
            </div>
            <div className="footer-socials">
              <a href="https://www.facebook.com/"   target="_blank" rel="noreferrer" aria-label="Facebook"><FiFacebook /></a>
              <a href="https://www.instagram.com//" target="_blank" rel="noreferrer" aria-label="Instagram"><FiInstagram /></a>
              <a href="https://www.youtube.com/"  target="_blank" rel="noreferrer" aria-label="YouTube"><FiYoutube /></a>
            </div>
          </div>

          {/* Links grid */}
          <div className="footer-links-grid">
            <div>
              <h4>Our Categories</h4>
              <Link to="/products?category=Laser+Printer+Parts">Laser Printer Parts</Link>
              <Link to="/products?category=Inkjet+Printer+Parts">Inkjet Printer Parts</Link>
              <Link to="/products?category=DMP+Printer+Parts">DMP Printer Parts</Link>
              <Link to="/products?category=Scanner+Parts">Scanner Parts</Link>
              <Link to="/products?category=Thermal+%2F+POS+Printer+Parts">Thermal / POS Parts</Link>
              <Link to="/products?category=Toner+Spare+Parts">Toner Spare Parts</Link>
            </div>
            <div>
              <h4>Shop by Brand</h4>
              <Link to="/products?brand=HP">HP</Link>
              <Link to="/products?brand=Canon">Canon</Link>
              <Link to="/products?brand=Epson">Epson</Link>
              <Link to="/products?brand=Brother">Brother</Link>
              <Link to="/products?brand=TVS">TVS</Link>
              <Link to="/products?brand=Samsung">Samsung</Link>
              <Link to="/products?brand=Ricoh">Ricoh</Link>
              <Link to="/products?brand=Kyocera">Kyocera</Link>
            </div>
            <div>
              <h4>My Account</h4>
              <Link to="/login">Sign In</Link>
              <Link to="/register">Create Account</Link>
              <Link to="/orders">Order History</Link>
              <Link to="/profile">My Profile</Link>
            </div>
            <div>
              <h4>Help & Policies</h4>
              <Link to="/orders">Track Your Order</Link>
              <Link to="/terms">Shipping Policy</Link>
              <Link to="/refund-policy">Refund Policy</Link>
              <Link to="/terms">Terms &amp; Conditions</Link>
              <Link to="/terms">COD Policy</Link>
              <Link to="/privacy-policy">Privacy Policy</Link>
              <a href="https://api.whatsapp.com/send/?phone=918467025204" target="_blank" rel="noreferrer">WhatsApp Support</a>
            </div>
          </div>
        </div>
      </div>

      {/* Payment / trust row */}
      <div className="footer-mid">
        <div className="container footer-mid-inner">
          <p>Accepted Payments</p>
          <div className="payment-methods">
            {['UPI', 'NEFT/RTGS', 'Paytm', 'GPay', 'PhonePe', 'COD'].map(p => (
              <span key={p} className="payment-chip">{p}</span>
            ))}
          </div>
          <div className="trust-badges">
            <span>🔒 SSL Secured</span>
            <span>📦 Pan-India Delivery</span>
            <span>🧾 GST Invoice Provided</span>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <p>© 2026 Ap Tech Solution.  All Rights Reserved.</p>
          <div className="footer-legal">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms">Terms &amp; Conditions</Link>
            <Link to="/terms">Shipping Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
